import { FaFacebookSquare, FaInstagram  } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { useTextService } from "../services/useTextService";
import phoneLv from "../img/reg-lv.png";
import phoneEn from "../img/reg-en.png";
import phoneMobileLv from "../img/reg-mobile-lv.png";
import phoneMobileEn from "../img/reg-mobile-en.png";

function Footer() {

  const { getPlainValueByTag } = useTextService();
  const currentLang = localStorage.getItem('lang') || 'lv';
  const phoneImage = currentLang === 'en' ? phoneEn : phoneLv;
  const phoneImageMobile = currentLang === 'en' ? phoneMobileEn : phoneMobileLv;
  const phoneAlt = currentLang === 'en' ? 'Phone for English support' : 'Phone for Latvian support';
  const phoneClass = currentLang === 'en' ? 'phone-image phone-en' : 'phone-image phone-lv';

  const PhoneImage = () => (
    <picture>
      <source media="(max-width: 768px)" srcSet={phoneImageMobile} />
      <img src={phoneImage} alt={phoneAlt} className={phoneClass} />
    </picture>
  );

  return (
    <div className="footer">
      <div className="footer-container">
        <ul className="left">
            <li><a href="/privatuma-politika">{getPlainValueByTag('privatuma-politika')}</a></li>
            <li><a href="/lietosanas-noteikumi">{getPlainValueByTag('lietosanas-noteikumi')}</a></li>
            <li><a href="/piegades-noteikumi">{getPlainValueByTag('piegades-noteikumi')}</a></li>
          </ul>
          <ul className="center">
            {/* <li><a href="/#veikals">Veikals</a></li>
            <li><a href="/instrukcija">Instrukcija</a></li>
            <li><a href="/questions">Jautājumi</a></li> */}
            <li>SIA "Nora Spora"</li>
            <li className="phones">
              <PhoneImage />
            </li>
          </ul>
          <ul className="right">
            <li><a href="https://www.instagram.com/nora.spora/" target="_blank" ><FaInstagram size={50}/></a></li>
            <li><a href="https://www.facebook.com/noraspora.lv/" target="_blank"><FaFacebookSquare size={50}/></a></li>
          </ul>
          
      </div>
      <ul className="mobile">
          <li>©NoraSpora 2024</li>
          <li className="phones">
            <PhoneImage />
          </li>
        </ul>
    </div>
  )
}

export default Footer
